document.addEventListener('DOMContentLoaded', function () {
  // Obtener todos los enlaces <a>
  var enlaces = document.querySelectorAll('a[href^="#modal-"]');

  // Iterar sobre cada enlace
  enlaces.forEach(function (enlace) {
    // Agregar un evento de clic a cada enlace
    enlace.addEventListener('click', function (event) {
      event.preventDefault(); // Evitar el comportamiento predeterminado del enlace

      // Obtener el ID del modal del atributo href
      var href = this.getAttribute('href');
      var modalId = href.split('#')[1]; // Obtener el ID del modal

      // Buscar el botón dentro del elemento <modal-opener> correspondiente
      var modalOpener = document.querySelector('modal-opener[data-modal="#PopupModal-' + modalId + '"]');
      if (modalOpener) {
        var boton = modalOpener.querySelector('button');
        if (boton) {
          // Simular un clic en el botón
          boton.click();
        } else {
          //console.error('No se encontró ningún botón dentro del modal opener:', modalId);
        }
      } else {
        //console.error('No se encontró ningún modal opener con el ID:', modalId);
      }
    });
  });
});
